import React from 'react'
import Country from '../../features/admin/Region/Country'

const CountryPage = () => {
  return <Country />
}

export default CountryPage